import { HomeContent } from "../../content/home";
import { Layout } from "../../layout/page";

export function Home() {
  return (
    <Layout>
      <HomeContent />
    </Layout>
  );
}
